import { del, get, post } from '@/lib/api';
import type { Workspace } from '@/types';

export async function listWorkspaces(): Promise<Workspace[]> {
  const res = await get<{ workspaces: Workspace[] } | Workspace[]>('/ide/workspaces');
  return Array.isArray(res) ? res : (res.workspaces ?? []);
}

export async function createWorkspace(
  name: string,
  templateId: string,
  projectId: string,
): Promise<Workspace> {
  return post<Workspace>('/ide/workspaces', { name, templateId, projectId });
}

export async function getWorkspace(id: string): Promise<Workspace> {
  return get<Workspace>(`/ide/workspaces/${id}`);
}

export async function deleteWorkspace(id: string): Promise<void> {
  return del<void>(`/ide/workspaces/${id}`);
}

export async function startWorkspace(id: string): Promise<Workspace> {
  return post<Workspace>(`/ide/workspaces/${id}/start`);
}

export async function stopWorkspace(id: string): Promise<Workspace> {
  return post<Workspace>(`/ide/workspaces/${id}/stop`);
}
